export default "__VITE_ASSET__BB6RKqDd__"